import { IFunnelRepository } from '../../../domain/repositories/IFunnelRepository';
import { Funnel } from '../../../types';

export class GetFunnelsUseCase {
    constructor(private funnelRepository: IFunnelRepository) { }

    async execute(organizationId?: string): Promise<Funnel[]> {
        return this.funnelRepository.findAll(organizationId);
    }
}
